"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("./config");
var _default = exports.default = {
  name: 'TablePagination',
  props: {
    page: {
      type: Object,
      default: () => ({
        currentPage: 1,
        size: 3,
        total: 0
      })
    },
    pageConfig: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    _pageConfig() {
      return Object.assign({
        pageSizes: [10, 20, 30, 50, 100],
        layout: 'total,prev,pager,next,sizes,jumper,->'
      }, this.pageConfig);
    },
    customClassName() {
      return this._pageConfig.customClassName || '';
    },
    elAttrs() {
      const copy = {};
      for (const key in this._pageConfig) {
        if (_config.elPageAttrs.includes(key)) {
          copy[key] = this._pageConfig[key];
        }
      }
      return copy;
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('current-change', val);
    },
    handleSizeChange(val) {
      this.$emit('size-change', val);
    }
  }
};